import React from 'react'
import DocumentTitle from 'react-document-title'
import { useHistory } from 'react-router'
import { useEffectOnce } from 'react-use'
import { Spinner } from 'transfix-ui/components/Spinner'
import { TopNav } from 'transfix-ui/components/TopNav'
import { BooleanParam, NumberParam, StringParam } from 'use-query-params'
import { useBreakpointContext } from 'utils/context/BreakpointContext'
import { useMarketplaceContext } from 'utils/context/MarketplaceContext'
import { useMembershipContext } from 'apps/fleet-planner/context/MembershipContext'
import { useTrackConversionContext } from 'apps/fleet-planner/context/track-conversion-source/TrackConversionContext'
import { WATERFALL_EMAIL_UTM_PARAM } from 'apps/fleet-planner/context/track-conversion-source/hooks/useTrackConversionParams'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'
import { useRateConfirmation } from 'apps/fleet-planner/hooks/useRateConfirmation'
import { IRateConfirmationParams } from 'apps/fleet-planner/types/mobileApp'
import { useQueryParams } from 'utils/hooks'
import { RateConfirmationForm } from './components/RateConfirmationForm'

export const RateConfirmation = () => {
  const { getAndPostReoffer, isShipmentLoaded, shipmentId } = useRateConfirmation()
  const { trackEvent } = useFMSAnalytics()
  const history = useHistory()
  const { isMobile } = useBreakpointContext()
  const { clearTrackConversionData, setTrackConversion, utmSource } = useTrackConversionContext()
  const { getMarketplaceLoad } = useMarketplaceContext()
  const { hasLoadedMotorCarrierUsers } = useMembershipContext()
  const [{ mobileApp, mobileAppSourceChannel, mobileAppSourceSegment }] = useQueryParams<
    IRateConfirmationParams
  >({
    mobileApp: BooleanParam,
    carrierId: NumberParam,
    mobileAppSourceChannel: StringParam,
    mobileAppSourceSegment: StringParam,
  })

  useEffectOnce(() => {
    if (utmSource === WATERFALL_EMAIL_UTM_PARAM) {
      getAndPostReoffer()
    } else {
      getMarketplaceLoad(shipmentId)
    }
    if (mobileApp) {
      setTrackConversion(mobileAppSourceChannel || 'mobile', mobileAppSourceSegment)
    }
    trackEvent('Rate Con', 'VIEWED_RATE_CONFIRMATION', { shipmentId })
  })

  const clickCancelHandler = () => {
    clearTrackConversionData()
    trackEvent('Rate Con', 'CANCELED_RATE_CONFIRMATION', { shipmentId })
    if (history?.length > 1) {
      history.goBack()
    } else {
      history.replace('/book')
    }
  }

  return (
    <>
      {isMobile && !mobileApp && (
        <TopNav
          showBackButton
          title='Confirm and book'
          showMenu={false}
          onPressBackButton={clickCancelHandler}
        />
      )}
      <DocumentTitle title='Rate Confirmation'>
        {isShipmentLoaded && hasLoadedMotorCarrierUsers ? (
          <RateConfirmationForm />
        ) : (
          <Spinner data-test='spinner' position='relative' />
        )}
      </DocumentTitle>
    </>
  )
}

export default RateConfirmation
